module.exports = __webpack_public_path__ + "static/labeling-mobile-9248a316256dbe19f9a5fc109a8b99bd.svg";